import { useState } from 'react'
import { Modal } from '@/components/ui/Modal'
import { Input } from '@/components/ui/Input'
import { Button } from '@/components/ui/Button'

interface PracticeCountModalProps {
  /** Cards in the vocabulary — the most a practice set can hold. */
  total: number
  onStart: (count: number) => void
  onClose: () => void
}

const SUGGESTED_COUNT = 20

/** Asks how many random cards to practise before a practice session starts. */
export function PracticeCountModal({ total, onStart, onClose }: PracticeCountModalProps) {
  const [value, setValue] = useState(String(Math.min(SUGGESTED_COUNT, total)))
  const count = Number(value)
  const valid = Number.isInteger(count) && count >= 1 && count <= total

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (valid) onStart(count)
  }

  return (
    <Modal open onClose={onClose} title="Random practice">
      <form onSubmit={handleSubmit} className="flex flex-col gap-5">
        <p className="text-sm text-muted font-light leading-relaxed">
          Cards are drawn at random from all {total} in your vocabulary, whatever their
          strength. Rate a card to update its strength, or skip it to leave it as is.
        </p>
        <Input
          id="practice-count"
          label="Number of words"
          type="number"
          inputMode="numeric"
          min={1}
          max={total}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <div className="flex justify-end gap-2">
          <Button variant="quiet" onClick={onClose} className="px-6 py-2.5 min-h-11">
            Cancel
          </Button>
          <Button type="submit" disabled={!valid} className="px-6 py-2.5 min-h-11">
            Start
          </Button>
        </div>
      </form>
    </Modal>
  )
}
